import { useTenantDetails } from '@/hooks/useConnections';

interface OnboardingStatusResult {
  isComplete: boolean;
  isLoading: boolean;
}

/**
 * Hook to check if onboarding is complete for the current tenant.
 *
 * Reads `is_onboarded` directly from the tenant details payload
 * returned by `GET /api/v1/session/tenant`.
 *
 * @returns Onboarding status with loading state.
 */
export function useOnboardingStatus (): OnboardingStatusResult {
  const { data: tenantDetails, isLoading: isTenantLoading } = useTenantDetails();

  if (isTenantLoading) {
    return { isComplete: false, isLoading: true };
  }

  return {
    isComplete: tenantDetails?.tenant?.is_onboarded === true,
    isLoading: false,
  };
}
